import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function PredictiveScoreCard({ jobId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!jobId) return;
    api.get(`/predict/approval/${jobId}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [jobId]);
  if (!data || data.score == null) return null;
  const color = data.score >= 75 ? "emerald" : data.score >= 50 ? "amber" : "red";
  const cls = { emerald: "border-emerald-500/30 bg-emerald-500/5 text-emerald-300", amber: "border-amber-500/30 bg-amber-500/5 text-amber-300", red: "border-red-500/30 bg-red-500/5 text-red-300" }[color];
  return (
    <div className={`rounded-xl border p-4 ${cls}`} data-testid="predictive-score">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2"><Sparkles className="w-4 h-4" /><div className="text-xs uppercase tracking-[0.22em] font-bold">Predicted Approval Likelihood</div></div>
        <Badge className="bg-slate-800 border-slate-700 text-slate-400 text-[10px]">{data.confidence} confidence</Badge>
      </div>
      <div className="flex items-end gap-3">
        <div className="font-display text-4xl font-bold">{data.score}<span className="text-base opacity-60">%</span></div>
        <div className="text-xs text-slate-400 mb-1">{data.carrier} · {data.historical_sample} historical samples</div>
      </div>
      <div className="text-[11px] text-slate-400 mt-2 leading-relaxed">{data.rationale}</div>
    </div>
  );
}
